export const metaClickEvents = (eName, params) => {
  if (window['fbq']) {
    window['fbq']('track', eName, {...params});
  }
};

export const ottoWhitelabelName = ottoName => {
  if (ottoName == null || ottoName == undefined || ottoName?.trim() == '') {
    return 'OTTO';
  }
  return ottoName;
};

export const whitelabelBrandColor = (isWhitelabel, brandColor) => {
  if (isWhitelabel) {
    if (brandColor == null || brandColor == undefined || brandColor?.trim() == '') {
      return '#7f4ead';
    }
    return brandColor;
  }
};

export const convertToErrorString = obj => {
  let errorString = '';

  function traverse(obj) {
    for (const key in obj) {
      if (Array.isArray(obj[key])) {
        errorString += `${obj[key].join(', ')}\n`;
      } else if (typeof obj[key] === 'object') {
        traverse(obj[key]);
      }
    }
  }

  traverse(obj);
  return errorString.trim();
};

export const getStandAloneLocations = (locations, searchValue, isV2=false) => {
  return locations?.length ? locations?.filter(location => {
    if (isV2) {
      if (searchValue) {
        if (location?.attributes?.businessName && location?.attributes?.usedInStandalone && location?.attributes?.businessName?.toLowerCase()?.includes(searchValue?.toLowerCase())) {
          return location;
        }
      } else {
        if (location?.attributes?.businessName && location?.attributes?.usedInStandalone) {
          return location;
        }
      }
    } else {
      if (searchValue) {
        if (location?.businessName && location?.usedInStandalone && location?.businessName?.toLowerCase()?.includes(searchValue?.toLowerCase())) {
          return location;
        }
      } else {
        if (location?.businessName && location?.usedInStandalone) {
          return location;
        }
      }
    }
  }) : [];
};

export const adjustLightness = (hex, amount) => {
  if (hex?.length === 4) {
    hex = `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;
  }
  let r = parseInt(hex?.slice(1, 3), 16);
  let g = parseInt(hex?.slice(3, 5), 16);
  let b = parseInt(hex?.slice(5, 7), 16);
  r = Math.max(0, Math.min(255, r + amount));
  g = Math.max(0, Math.min(255, g + amount));
  b = Math.max(0, Math.min(255, b + amount));
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};

export const hexToRgba = (hex, alpha) => {
  let r = 0; let g = 0; let b = 0;
  if (hex?.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);
  } else if (hex?.length === 7) {
    r = parseInt(hex[1] + hex[2], 16);
    g = parseInt(hex[3] + hex[4], 16);
    b = parseInt(hex[5] + hex[6], 16);
  }
  return `rgba(${r},${g},${b},${alpha})`;
};

export const getLastUpdated = (lastUpdatedDate: string) => {
  let label;
  let difference;
  const now = new Date().getTime();
  const lastUpdatedAt = new Date(lastUpdatedDate).getTime();
  difference = (now - lastUpdatedAt) / 1000;

  if (difference < 60) {
    label = 'seconds ago';
  }

  if (difference >= 60 && difference < 3600) {
    difference = Math.round(difference / 60);
    if (difference < 2) {
      label = 'minute ago';
    } else {
      label = 'minutes ago';
    }
  }

  if (difference >= 3600 && difference < 86400) {
    difference = Math.round(difference / 3600);
    if (difference < 2) {
      label = 'hour ago';
    } else {
      label = 'hours ago';
    }
  }

  if (difference >= 86400) {
    difference = Math.round(difference / 86400);
    if (difference < 2) {
      label = 'day ago';
    } else {
      label = 'days ago';
    }
  }

  return difference ? `${Math.round(difference)} ${label} ` : '';
};

export const removeZeroWidthCharactersFromString = (value: string) => {
  return value.replace(/[\u200B-\u200D\uFEFF]/g, '');
};

export function getPayloadSizeInMb(payload) {
  const jsonString = JSON.stringify(payload); // Convert object to JSON string
  const byteSize = new TextEncoder().encode(jsonString).length; // Get byte size
  return parseFloat((byteSize/1048576).toFixed(1));
}

export const formatNumber = num => {
  if (!num) return '0';

  const units = ['', 'K', 'M', 'B', 'T'];
  const index = Math.floor(Math.log10(Math.abs(num)) / 3);
  const scaled = num / Math.pow(10, index * 3);

  return `${scaled.toFixed(2).replace(/\.00$/, '')}${units[index]}`;
};

export const calculateSumFromArray = (data, key) => data?.reduce((acc, b) => acc + + (b?.[key] || 0), 0);

export function convertMarkdownToUnicode(markdownText: string): string {
  if (!markdownText) return '';

  const isLetter = (char: string) => /[a-zA-Z]/.test(char);
  const isDigit = (char: string) => /\d/.test(char);

  const boldMap: { [key: string]: string } = {
    'A': '𝗔', 'B': '𝗕', 'C': '𝗖', 'D': '𝗗', 'E': '𝗘', 'F': '𝗙', 'G': '𝗚', 'H': '𝗛', 'I': '𝗜',
    'J': '𝗝', 'K': '𝗞', 'L': '𝗟', 'M': '𝗠', 'N': '𝗡', 'O': '𝗢', 'P': '𝗣', 'Q': '𝗤', 'R': '𝗥',
    'S': '𝗦', 'T': '𝗧', 'U': '𝗨', 'V': '𝗩', 'W': '𝗪', 'X': '𝗫', 'Y': '𝗬', 'Z': '𝗭',
    'a': '𝗮', 'b': '𝗯', 'c': '𝗰', 'd': '𝗱', 'e': '𝗲', 'f': '𝗳', 'g': '𝗴', 'h': '𝗵', 'i': '𝗶',
    'j': '𝗷', 'k': '𝗸', 'l': '𝗹', 'm': '𝗺', 'n': '𝗻', 'o': '𝗼', 'p': '𝗽', 'q': '𝗾', 'r': '𝗿',
    's': '𝘀', 't': '𝘁', 'u': '𝘂', 'v': '𝘃', 'w': '𝘄', 'x': '𝘅', 'y': '𝘆', 'z': '𝘇',
    '0': '𝟎', '1': '𝟏', '2': '𝟐', '3': '𝟑', '4': '𝟒', '5': '𝟓', '6': '𝟔', '7': '𝟕', '8': '𝟖', '9': '𝟗',
  };

  const italicMap: { [key: string]: string } = {
    'A': '𝘈', 'B': '𝘉', 'C': '𝘊', 'D': '𝘋', 'E': '𝘌', 'F': '𝘍', 'G': '𝘎', 'H': '𝘏', 'I': '𝘐',
    'J': '𝘑', 'K': '𝘒', 'L': '𝘓', 'M': '𝘔', 'N': '𝘕', 'O': '𝘖', 'P': '𝘗', 'Q': '𝘘', 'R': '𝘙',
    'S': '𝘚', 'T': '𝘛', 'U': '𝘜', 'V': '𝘝', 'W': '𝘞', 'X': '𝘟', 'Y': '𝘠', 'Z': '𝘡',
    'a': '𝘢', 'b': '𝘣', 'c': '𝘤', 'd': '𝘥', 'e': '𝘦', 'f': '𝘧', 'g': '𝘨', 'h': '𝘩', 'i': '𝘪',
    'j': '𝘫', 'k': '𝘬', 'l': '𝘭', 'm': '𝘮', 'n': '𝘯', 'o': '𝘰', 'p': '𝘱', 'q': '𝘲', 'r': '𝘳',
    's': '𝘴', 't': '𝘵', 'u': '𝘶', 'v': '𝘷', 'w': '𝘸', 'x': '𝘹', 'y': '𝘺', 'z': '𝘻',
    '0': '0', '1': '1', '2': '2', '3': '3', '4': '4', '5': '5', '6': '6', '7': '7', '8': '8', '9': '9',
  };

  const boldItalicMap: { [key: string]: string } = {
    'A': '𝘼', 'B': '𝘽', 'C': '𝘾', 'D': '𝘿', 'E': '𝙀', 'F': '𝙁', 'G': '𝙂', 'H': '𝙃',
    'I': '𝙄', 'J': '𝙅', 'K': '𝙆', 'L': '𝙇', 'M': '𝙈', 'N': '𝙉', 'O': '𝙊', 'P': '𝙋',
    'Q': '𝙌', 'R': '𝙍', 'S': '𝙎', 'T': '𝙏', 'U': '𝙐', 'V': '𝙑', 'W': '𝙒', 'X': '𝙓',
    'Y': '𝙔', 'Z': '𝙕',
    'a': '𝙖', 'b': '𝙗', 'c': '𝙘', 'd': '𝙙', 'e': '𝙚', 'f': '𝙛', 'g': '𝙜', 'h': '𝙝',
    'i': '𝙞', 'j': '𝙟', 'k': '𝙠', 'l': '𝙡', 'm': '𝙢', 'n': '𝙣', 'o': '𝙤', 'p': '𝙥',
    'q': '𝙦', 'r': '𝙧', 's': '𝙨', 't': '𝙩', 'u': '𝙪', 'v': '𝙫', 'w': '𝙬', 'x': '𝙭',
    'y': '𝙮', 'z': '𝙯',
    '0': '𝟬', '1': '𝟭', '2': '𝟮', '3': '𝟯', '4': '𝟰', '5': '𝟱', '6': '𝟲', '7': '𝟳', '8': '𝟴', '9': '𝟵',
  };

  let result = markdownText;

  // Handle ***bold italic***
  result = result.replace(/\*\*\*(.+?)\*\*\*/g, (_, text: string) => {
    return Array.from(text).map(char => {
      if (isLetter(char) || isDigit(char)) return boldItalicMap[char] || char;
      return char;
    }).join('');
  });

  // Handle **bold**
  result = result.replace(/\*\*(.+?)\*\*/g, (_, text: string) => {
    return Array.from(text).map(char => {
      if (isLetter(char) || isDigit(char)) return boldMap[char] || char;
      return char;
    }).join('');
  });

  // Handle *italic*
  result = result.replace(/\*(.+?)\*/g, (_, text: string) => {
    return Array.from(text).map(char => {
      if (isLetter(char)) return italicMap[char] || char;
      return char;
    }).join('');
  });

  return result;
}

export function convertUnicodeToMarkdown(input: string): string {
  if (!input) return '';

  const boldMap: Record<string, string> = {
    '𝗔': 'A', '𝗕': 'B', '𝗖': 'C', '𝗗': 'D', '𝗘': 'E', '𝗙': 'F', '𝗚': 'G', '𝗛': 'H', '𝗜': 'I',
    '𝗝': 'J', '𝗞': 'K', '𝗟': 'L', '𝗠': 'M', '𝗡': 'N', '𝗢': 'O', '𝗣': 'P', '𝗤': 'Q', '𝗥': 'R',
    '𝗦': 'S', '𝗧': 'T', '𝗨': 'U', '𝗩': 'V', '𝗪': 'W', '𝗫': 'X', '𝗬': 'Y', '𝗭': 'Z',
    '𝗮': 'a', '𝗯': 'b', '𝗰': 'c', '𝗱': 'd', '𝗲': 'e', '𝗳': 'f', '𝗴': 'g', '𝗵': 'h', '𝗶': 'i',
    '𝗷': 'j', '𝗸': 'k', '𝗹': 'l', '𝗺': 'm', '𝗻': 'n', '𝗼': 'o', '𝗽': 'p', '𝗾': 'q', '𝗿': 'r',
    '𝘀': 's', '𝘁': 't', '𝘂': 'u', '𝘃': 'v', '𝘄': 'w', '𝘅': 'x', '𝘆': 'y', '𝘇': 'z',
    '𝟬': '0', '𝟭': '1', '𝟮': '2', '𝟯': '3', '𝟰': '4', '𝟱': '5', '𝟲': '6', '𝟳': '7', '𝟴': '8', '𝟵': '9',
  };

  const italicMap: Record<string, string> = {
    '𝘈': 'A', '𝘉': 'B', '𝘊': 'C', '𝘋': 'D', '𝘌': 'E', '𝘍': 'F', '𝘎': 'G', '𝘏': 'H', '𝘐': 'I',
    '𝘑': 'J', '𝘒': 'K', '𝘓': 'L', '𝘔': 'M', '𝘕': 'N', '𝘖': 'O', '𝘗': 'P', '𝘘': 'Q', '𝘙': 'R',
    '𝘚': 'S', '𝘛': 'T', '𝘜': 'U', '𝘝': 'V', '𝘞': 'W', '𝘟': 'X', '𝘠': 'Y', '𝘡': 'Z',
    '𝘢': 'a', '𝘣': 'b', '𝘤': 'c', '𝘥': 'd', '𝘦': 'e', '𝘧': 'f', '𝘨': 'g', '𝘩': 'h', '𝘪': 'i',
    '𝘫': 'j', '𝘬': 'k', '𝘭': 'l', '𝘮': 'm', '𝘯': 'n', '𝘰': 'o', '𝘱': 'p', '𝘲': 'q', '𝘳': 'r',
    '𝘴': 's', '𝘵': 't', '𝘶': 'u', '𝘷': 'v', '𝘸': 'w', '𝘹': 'x', '𝘺': 'y', '𝘻': 'z',
    '𝟢': '0', '𝟣': '1', '𝟤': '2', '𝟥': '3', '𝟦': '4', '𝟧': '5', '𝟨': '6', '𝟩': '7', '𝟪': '8', '𝟫': '9',
  };

  const boldItalicMap: Record<string, string> = {
    '𝘼': 'A', '𝘽': 'B', '𝘾': 'C', '𝘿': 'D', '𝙀': 'E', '𝙁': 'F', '𝙂': 'G', '𝙃': 'H', '𝙄': 'I',
    '𝙅': 'J', '𝙆': 'K', '𝙇': 'L', '𝙈': 'M', '𝙉': 'N', '𝙊': 'O', '𝙋': 'P', '𝙌': 'Q', '𝙍': 'R',
    '𝙎': 'S', '𝙏': 'T', '𝙐': 'U', '𝙑': 'V', '𝙒': 'W', '𝙓': 'X', '𝙔': 'Y', '𝙕': 'Z',
    '𝙖': 'a', '𝙗': 'b', '𝙘': 'c', '𝙙': 'd', '𝙚': 'e', '𝙛': 'f', '𝙜': 'g', '𝙝': 'h', '𝙞': 'i',
    '𝙟': 'j', '𝙠': 'k', '𝙡': 'l', '𝙢': 'm', '𝙣': 'n', '𝙤': 'o', '𝙥': 'p', '𝙦': 'q', '𝙧': 'r',
    '𝙨': 's', '𝙩': 't', '𝙪': 'u', '𝙫': 'v', '𝙬': 'w', '𝙭': 'x', '𝙮': 'y', '𝙯': 'z',
    '𝟬': '0', '𝟭': '1', '𝟮': '2', '𝟯': '3', '𝟰': '4', '𝟱': '5', '𝟲': '6', '𝟳': '7', '𝟴': '8', '𝟵': '9',
  };

  const getStyle = (char: string): 'boldItalic' | 'bold' | 'italic' | null => {
    if (boldItalicMap[char]) return 'boldItalic';
    if (boldMap[char]) return 'bold';
    if (italicMap[char]) return 'italic';
    if (char==' ') return currentStyle;
    return null;
  };

  const getOriginal = (char: string): string =>
    boldItalicMap[char] || boldMap[char] || italicMap[char] || char;

  let result = '';
  let buffer = '';
  let currentStyle: 'boldItalic' | 'bold' | 'italic' | null = null;

  for (const char of [...input]) {
    const style = getStyle(char);
    const isStyled = style !== null;

    if (style === currentStyle) {
      buffer += getOriginal(char);
    } else {
      if (buffer) {
        if (currentStyle === 'boldItalic') result += `***${buffer}***`;
        else if (currentStyle === 'bold') result += `**${buffer}**`;
        else if (currentStyle === 'italic') result += `*${buffer}*`;
        else result += buffer;
        buffer = '';
      }

      if (isStyled) {
        buffer = getOriginal(char);
        currentStyle = style;
      } else {
        result += getOriginal(char);
        currentStyle = style;
      }
    }
  }

  if (buffer) {
    if (currentStyle === 'boldItalic') result += `***${buffer}***`;
    else if (currentStyle === 'bold') result += `**${buffer}**`;
    else if (currentStyle === 'italic') result += `*${buffer}*`;
    else result += buffer;
  }

  return result;
}

export const formatTypeToReadable = (type: string): string => {
  if (!type) return '-';
  return type
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const isDuplicate = (email, index, recipientEmails) => {
  if (!email.trim()) return false;
  const normalized = email.trim().toLowerCase();
  return recipientEmails.some((e, i) =>
    i !== index &&
    e.trim() &&
    e.trim().toLowerCase() === normalized,
  );
};

export const getDynamicFontSize = (value: number | string, baseFontSize: number = 25, baseDigits: number = 5, minFontSize: number = 16) => {
  const digits = String(value).replace(/\D/g, '').length;
  if (digits <= baseDigits) return baseFontSize;
  return Math.max(minFontSize, baseFontSize - (digits - baseDigits) * 3);
};
